<template>
    <div class="component-wrap" data-app="true">
        <Header-menu />
        <div class="wrapper">
            <User-menu />
            <v-layout row wrap :class="{'pa-0': $vuetify.breakpoint.xs,'pa-4' : $vuetify.breakpoint.smAndUp}">
                <v-breadcrumbs class="my-4 pl-0" :class="{'mx-3': $vuetify.breakpoint.xs}">
                    <v-icon slot="divider" aria-hidden="true" translate="no">keyboard_arrow_left</v-icon>
                    <router-link to="/">
                        <v-breadcrumbs-item>
                            <v-icon class="mr-1" aria-hidden="true" translate="no">keyboard_arrow_left</v-icon> {{$t("Главная")}}
                        </v-breadcrumbs-item>
                    </router-link>
                    <router-link to="/news_main">
                        <v-breadcrumbs-item>
                            <v-icon class="mr-1" aria-hidden="true" translate="no">keyboard_arrow_left</v-icon> {{$t("Новости и мероприятия")}}
                        </v-breadcrumbs-item>
                    </router-link>
                </v-breadcrumbs>
                <DetailPage />
            </v-layout>

        </div>
        <FooterBlock />
    </div>

</template>

<script>
import DetailPage from '../components/view_blocks/News_main/news_page_detail';
import HeaderMenu    from '@/components/blocks/common/Header_menu.vue';
import UserMenu      from '@/components/blocks/common/User_menu.vue';
import FooterBlock   from '@/components/blocks/common/Footer.vue';
import {mapGetters} from 'vuex';
export default {
  components: {
    DetailPage, HeaderMenu, UserMenu, FooterBlock,
  },
  computed: {
    ...mapGetters('profile/breadcrumbs', [
      'breadcrumbs',
    ]),
    // ...mapGetters(''),
  },
};
</script>
